import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSENGER_SENDER_ID
};

const fire = firebase.initializeApp(config);
const storage = firebase.storage();

// Local development only: opt in to the Firebase Auth emulator by setting
// REACT_APP_AUTH_EMULATOR_URL (e.g. http://localhost:9099) in .env.local.
// Lets auth flows be exercised end-to-end without touching real accounts.
// Unset in production builds, so this is dead code there.
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_AUTH_EMULATOR_URL) {
  fire.auth().useEmulator(process.env.REACT_APP_AUTH_EMULATOR_URL);
}

export { storage, fire as default };
